import React from 'react';

// Green Approval Illustration
export const GreenApprovalIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Leaf shapes */}
    <path d="M60 80 Q50 70 60 50 Q70 60 70 80 Q70 100 60 110 L60 80" fill="#4bc190" opacity="0.8"/>
    <path d="M140 60 Q150 50 160 65 Q155 75 140 80 Q130 75 140 60" fill="#4bc190" opacity="0.6"/>
    <path d="M100 90 Q90 80 85 65 Q95 70 105 75 Q110 85 100 90" fill="#4bc190" opacity="0.7"/>
    {/* Checkmark */}
    <g transform="translate(120, 130)">
      <circle cx="0" cy="0" r="25" fill="none" stroke="#4bc190" strokeWidth="2"/>
      <path d="M-8 0 L2 10 L12 -5" fill="none" stroke="#4bc190" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    {/* Document lines */}
    <rect x="40" y="150" width="60" height="35" rx="2" fill="none" stroke="#564787" strokeWidth="1.5"/>
    <line x1="45" y1="160" x2="95" y2="160" stroke="#564787" strokeWidth="1"/>
    <line x1="45" y1="168" x2="95" y2="168" stroke="#564787" strokeWidth="1"/>
    <line x1="45" y1="176" x2="85" y2="176" stroke="#564787" strokeWidth="1"/>
  </svg>
);

// Licences & Approval Illustration
export const LicencesApprovalIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Stacked documents */}
    <g transform="translate(70, 60)">
      <rect x="0" y="0" width="60" height="75" rx="2" fill="#564787" opacity="0.2" stroke="#564787" strokeWidth="2"/>
      <rect x="5" y="-5" width="60" height="75" rx="2" fill="#564787" opacity="0.4" stroke="#564787" strokeWidth="2"/>
      <rect x="10" y="-10" width="60" height="75" rx="2" fill="#564787" stroke="#564787" strokeWidth="2"/>
    </g>
    {/* Seal/Badge */}
    <g transform="translate(65, 145)">
      <circle cx="0" cy="0" r="22" fill="none" stroke="#9ad4d6" strokeWidth="2"/>
      <circle cx="0" cy="0" r="18" fill="none" stroke="#9ad4d6" strokeWidth="1"/>
      <text x="-3" y="2" fontSize="10" fontWeight="bold" fill="#9ad4d6">✓</text>
    </g>
    {/* Ribbon tail */}
    <path d="M 65 167 Q 50 175 45 190" stroke="#9ad4d6" strokeWidth="2" fill="none" strokeLinecap="round"/>
  </svg>
);

// EPF/ESI Illustration
export const EPFESIIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Briefcase */}
    <rect x="50" y="70" width="100" height="65" rx="3" fill="none" stroke="#564787" strokeWidth="2.5"/>
    <rect x="50" y="70" width="100" height="20" rx="3" fill="#564787" opacity="0.1" stroke="#564787" strokeWidth="2.5"/>
    {/* Handle */}
    <path d="M70 70 Q70 50 100 50 Q130 50 130 70" fill="none" stroke="#564787" strokeWidth="2"/>
    {/* Dividers in case */}
    <line x1="80" y1="90" x2="80" y2="130" stroke="#9ad4d6" strokeWidth="1.5"/>
    <line x1="120" y1="90" x2="120" y2="130" stroke="#9ad4d6" strokeWidth="1.5"/>
    {/* Coins/money symbols in sections */}
    <circle cx="65" cy="110" r="8" fill="none" stroke="#9ad4d6" strokeWidth="1.5"/>
    <text x="61" y="115" fontSize="8" fill="#9ad4d6">₹</text>
    <circle cx="100" cy="110" r="8" fill="none" stroke="#9ad4d6" strokeWidth="1.5"/>
    <text x="97" y="115" fontSize="8" fill="#9ad4d6">€</text>
    <circle cx="135" cy="110" r="8" fill="none" stroke="#9ad4d6" strokeWidth="1.5"/>
    <text x="133" y="115" fontSize="8" fill="#9ad4d6">$</text>
  </svg>
);

// Compliance Services Illustration
export const ComplianceServicesIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Scales of Justice */}
    <g transform="translate(100, 100)">
      <path d="M-30 0 L30 0" stroke="#ff9f43" strokeWidth="2"/>
      <path d="M0 -30 L0 30" stroke="#ff9f43" strokeWidth="2"/>
      <path d="M-25 -15 Q-30 -20 -25 -25 Q-20 -30 -15 -25 Q-10 -20 -15 -15" fill="none" stroke="#ff9f43" strokeWidth="1.5"/>
      <path d="M25 -15 Q20 -20 25 -25 Q30 -30 35 -25 Q40 -20 40 -15 Q35 -10 25 -10" fill="none" stroke="#ff9f43" strokeWidth="1.5"/>
      <circle cx="0" cy="0" r="8" fill="#ff9f43"/>
    </g>
    {/* Document */}
    <rect x="60" y="120" width="80" height="50" rx="3" fill="none" stroke="#ff9f43" strokeWidth="2"/>
    <line x1="70" y1="140" x2="130" y2="140" stroke="#ff9f43" strokeWidth="1"/>
    <line x1="70" y1="150" x2="130" y2="150" stroke="#ff9f43" strokeWidth="1"/>
    <line x1="70" y1="160" x2="120" y2="160" stroke="#ff9f43" strokeWidth="1"/>
  </svg>
);

// HR Audit Illustration
export const HRAuditIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Clipboard */}
    <rect x="60" y="50" width="80" height="100" rx="5" fill="none" stroke="#10ac84" strokeWidth="2"/>
    <rect x="60" y="50" width="80" height="20" rx="5" fill="#10ac84" opacity="0.1" stroke="#10ac84" strokeWidth="2"/>
    {/* Checklist */}
    <line x1="70" y1="80" x2="130" y2="80" stroke="#10ac84" strokeWidth="1.5"/>
    <line x1="70" y1="95" x2="130" y2="95" stroke="#10ac84" strokeWidth="1.5"/>
    <line x1="70" y1="110" x2="130" y2="110" stroke="#10ac84" strokeWidth="1.5"/>
    <line x1="70" y1="125" x2="130" y2="125" stroke="#10ac84" strokeWidth="1.5"/>
    <line x1="70" y1="140" x2="130" y2="140" stroke="#10ac84" strokeWidth="1.5"/>
    {/* Check marks */}
    <path d="M75 75 L82 82 L95 70" fill="none" stroke="#10ac84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M75 90 L82 97 L95 85" fill="none" stroke="#10ac84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M75 105 L82 112 L95 100" fill="none" stroke="#10ac84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M75 120 L82 127 L95 115" fill="none" stroke="#10ac84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M75 135 L82 142 L95 130" fill="none" stroke="#10ac84" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Compensation & Pay Roll Illustration
export const CompensationPayrollIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Dollar/Euro/Rupee symbols */}
    <g transform="translate(100, 100)">
      <text x="-30" y="0" fontSize="24" fill="#ee5a24">$</text>
      <text x="0" y="0" fontSize="24" fill="#ee5a24">€</text>
      <text x="30" y="0" fontSize="24" fill="#ee5a24">₹</text>
    </g>
    {/* Chart bars */}
    <rect x="50" y="120" width="20" height="50" fill="#ee5a24" opacity="0.7" rx="2"/>
    <rect x="90" y="100" width="20" height="70" fill="#ee5a24" opacity="0.8" rx="2"/>
    <rect x="130" y="80" width="20" height="90" fill="#ee5a24" opacity="0.9" rx="2"/>
    {/* Calculator buttons */}
    <rect x="70" y="150" width="15" height="15" rx="2" fill="none" stroke="#ee5a24" strokeWidth="1.5"/>
    <rect x="95" y="150" width="15" height="15" rx="2" fill="none" stroke="#ee5a24" strokeWidth="1.5"/>
    <rect x="120" y="150" width="15" height="15" rx="2" fill="none" stroke="#ee5a24" strokeWidth="1.5"/>
  </svg>
);

// Training & Development Illustration
export const TrainingDevelopmentIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Graduation cap */}
    <path d="M80 60 Q100 30 120 60 L120 80 L80 80 Z" fill="#3742fa" opacity="0.2" stroke="#3742fa" strokeWidth="2"/>
    <rect x="90" y="40" width="20" height="5" rx="2" fill="#3742fa"/>
    {/* Books */}
    <rect x="60" y="100" width="30" height="50" rx="3" fill="none" stroke="#3742fa" strokeWidth="2"/>
    <rect x="110" y="100" width="30" height="50" rx="3" fill="none" stroke="#3742fa" strokeWidth="2"/>
    <line x1="75" y1="115" x2="125" y2="115" stroke="#3742fa" strokeWidth="1"/>
    <line x1="75" y1="130" x2="125" y2="130" stroke="#3742fa" strokeWidth="1"/>
    <line x1="125" y1="115" x2="175" y2="115" stroke="#3742fa" strokeWidth="1"/>
    <line x1="125" y1="130" x2="175" y2="130" stroke="#3742fa" strokeWidth="1"/>
  </svg>
);

// Industrial Relations Illustration
export const IndustrialRelationsIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Handshake */}
    <g transform="translate(100, 120)">
      <path d="M-20 0 Q-10 -15 0 -10 Q10 -15 20 0 L20 20 Q15 25 10 20 Q5 25 0 20 L-20 20 Q-15 25 -10 20 Q-5 25 -20 20 Z" fill="#2ed573" opacity="0.2" stroke="#2ed573" strokeWidth="2"/>
      <path d="M0 -10 Q5 -25 15 -10" fill="none" stroke="#2ed573" strokeWidth="2"/>
      <path d="M0 -10 Q-5 -25 -15 -10" fill="none" stroke="#2ed573" strokeWidth="2"/>
    </g>
    {/* Gear */}
    <g transform="translate(100, 80)">
      <path d="M0 -25 L0 -20 M0 20 L0 25 M-20 0 L-15 0 M20 0 L15 0" stroke="#2ed573" strokeWidth="2"/>
      <path d="M-18 -18 L-14 -14 M14 14 L18 18 M-14 18 L-10 22 M10 -22 L14 -18" stroke="#2ed573" strokeWidth="2"/>
      <circle cx="0" cy="0" r="12" fill="none" stroke="#2ed573" strokeWidth="2"/>
    </g>
  </svg>
);

// Other Activities Illustration
export const OtherActivitiesIllustration = () => (
  <svg viewBox="0 0 200 200" className="service-illustration">
    <rect width="200" height="200" fill="none"/>
    {/* Shield */}
    <path d="M100 30 L120 50 L120 90 L100 130 L80 90 L80 50 Z" fill="#ff6b6b" opacity="0.2" stroke="#ff6b6b" strokeWidth="2"/>
    {/* First aid cross */}
    <rect x="90" y="70" width="20" height="40" fill="#ff6b6b"/>
    <rect x="80" y="80" width="40" height="20" fill="#ff6b6b"/>
    {/* Safety check */}
    <path d="M70 110 L85 125 L110 100" fill="none" stroke="#ff6b6b" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// SVG wrapper component
export const ServiceIllustration = ({ type }) => {
  const illustrations = {
    'green-approval': <GreenApprovalIllustration />,
    'licences-approval': <LicencesApprovalIllustration />,
    'epf-esi': <EPFESIIllustration />,
    'compliance-services': <ComplianceServicesIllustration />,
    'hr-audit': <HRAuditIllustration />,
    'compensation-payroll': <CompensationPayrollIllustration />,
    'training-development': <TrainingDevelopmentIllustration />,
    'industrial-relations': <IndustrialRelationsIllustration />,
    'other-activities': <OtherActivitiesIllustration />
  };

  return illustrations[type] || null;
};

export default ServiceIllustration;
